/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespShippingReturns_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_user" | "PdpSharedBuyerProtectionBox_user">;
    readonly " $refType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$data = PdpRespShippingReturns_user;
export type PdpRespShippingReturns_user$key = {
    readonly " $data"?: PdpRespShippingReturns_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '33ed795f66f69083fbfb0296e9eaa09b';
export default node;
